import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { claimedOrdersSelector, dismissClaimedOrders } from "../redux/globalSlice"
import { oneTimeIcon } from "./widgets/pillIcons"

// The one-time notice for guest purchases that just landed: a store purchase
// made signed-out is parked for its email and materializes into ordinary
// orders on the first app load by an account with that email (/me returns
// what it materialized). A banner, not a dialog, so it never competes with
// the launch dialogs (policy consent, iLok notice); it rides above every
// page until dismissed or followed, and there is nothing to remember — the
// materialization itself happens once. Several purchases fold into one
// sentence.
export default function ClaimedOrdersBanner() {
  const claimed = useSelector(claimedOrdersSelector)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  if (claimed.length === 0) return null

  const dismiss = () => dispatch(dismissClaimedOrders())
  const names = claimed.map((o, i) => (
    <Fragment key={o.orderId}>
      {i > 0 && (i === claimed.length - 1 ? " and " : ", ")}
      <strong>{o.skuName}</strong>
    </Fragment>
  ))
  const orderNumbers = claimed.map(o => `#${o.storeOrderNumber}`).join(", ")
  const onLicenses = location.pathname === "/licenses"

  return (
    <div className="notice-banner" role="status">
      <span className="notice-banner-icon" aria-hidden="true">{oneTimeIcon}</span>
      <span className="notice-banner-text">
        {claimed.length === 1
          ? <>Your purchase of {names} (order {orderNumbers}) has been added to your account.</>
          : <>Your purchases of {names} (orders {orderNumbers}) have been added to your account.</>}
        {" "}Your licenses are ready to use.
      </span>
      <div className="notice-banner-actions">
        {!onLicenses && (
          <button className="btn-upgrade" onClick={() => { dismiss(); navigate("/licenses") }}>
            View licenses
          </button>
        )}
        <button className="notice-banner-dismiss" onClick={dismiss} aria-label="Dismiss" title="Dismiss">
          &times;
        </button>
      </div>
    </div>
  )
}
